export default function UpArrow() {
  // Triangle icons from https://svgbox.net/iconset/octicons
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="5.68 8.68 12.62 6.82"
      className="w-8 h-8"
    >
      <path d="M12.354 8.854l5.792 5.792a.5.5 0 01-.353.854H6.207a.5.5 0 01-.353-.854l5.792-5.792a.5.5 0 01.708 0z"></path>
    </svg>
  );
}
